import styled from 'styled-components';

import { sp } from '@main/theme';

/*
 * Wrapper for the opt out success on the privacy settings
 */
export const OptOutSuccess = styled.div`
  color: ${({ theme }) => theme.colors.black};
  width: 100%;
  padding: ${sp(1)};
`;
